import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createHead } from '@unhead/vue'
import App from './App.vue'
import router from './router'
import { useThemeStore } from './stores/themeStore'
import { useAuthStore } from './stores/authStore'
import './assets/tailwind.css'

const app = createApp(App)
const pinia = createPinia()
const head = createHead()

app.use(pinia)
app.use(router)
app.use(head)

// Initialize theme + restore auth session before mount so the first paint
// already has the right colors and routing decisions reflect login state.
const themeStore = useThemeStore()
themeStore.initialize()

const authStore = useAuthStore()
authStore.restoreSession().finally(() => {
  app.mount('#app')
})
